module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/tooltipHelper.4bdb2483.svg";